import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { FormControl, MenuItem, Select, Stack, Typography, Skeleton } from '@mui/material'

import ModalDashboardSettingComponent from '../../modal-dashboard/ModalDashboardSettingComponent'

import { useSummaryDefaultProjectFormInfo } from '../utils/hooks/summaryHeaderQuery'
import { useJobSummaryViewReducer } from '../../job-summary/helper/reducers/jobViewReducer'

import {
	SUMMARY_TYPES,
	AVAILABLE_JOB_COLUMN_NAMES,
	LABEL_FOR_TYPE,
	TASK_MAP_SETTING_TYPES,
} from '../utils/constant'
import { DISPLAY_COLUMNS } from '../../job-summary/helper/constant'
import PlottingMapForm from '../../plotting-map/PlottingMapForm'

function NewJobSummaryForm({ filterData, onFilterDataChange, tileType }) {
	const [t] = useTranslation()

	// default view hook
	const { selectedJobForm, projectLoading } = useSummaryDefaultProjectFormInfo({
		summaryType: SUMMARY_TYPES.JOB,
	})

	const { allColumns, viewLoading } = useJobSummaryViewReducer({
		formKey: selectedJobForm?.formKey,
		projectKey: selectedJobForm?.projectKey,
	})

	const displayJobColumns = useMemo(() => {
		const ordered = AVAILABLE_JOB_COLUMN_NAMES.map((name) =>
			allColumns.find((col) => col.title === name)
		).filter(Boolean)

		return ordered.map((column) => ({
			...column,
			title: DISPLAY_COLUMNS[column.name] || column.title,
		}))
	}, [allColumns])

	return (
		<Stack spacing={2}>
			{projectLoading || viewLoading ? (
				<Skeleton variant="rectangular" height={180} sx={{ mb: 1 }} />
			) : (
				<>
					<FormControl ariant="outlined" size="small" sx={{ minWidth: '100px' }}>
						<Typography variant="subtitle2" sx={{ pl: 1 }}>
							{t('common:input.progressField')}
						</Typography>
						<Select
							value={filterData?.progressBarField || ''}
							onChange={(e) => {
								const newValue = e.target.value
								onFilterDataChange('progressBarField', newValue)
							}}
							size="small"
							fullWidth
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							{displayJobColumns.map((col) => (
								<MenuItem value={col.name}>{col.title}</MenuItem>
							))}
						</Select>
					</FormControl>
					{/* <FormControl variant="outlined" size="small" sx={{ mr: '5px', minWidth: '80px' }}>
						<Typography variant="subtitle2" sx={{ pl: 1 }}>
							{t('common:input.filterField')}
						</Typography>
						<Select
							value={filterData?.filterField || ''}
							onChange={(e) => {
								const newValue = e.target.value
								onFilterDataChange('filterField', newValue)
							}}
							size="small"
						>
							<MenuItem value="">
								<em>None</em>
							</MenuItem>
							{displayJobColumns.map((col) => (
								<MenuItem value={col.name}>{col.title}</MenuItem>
							))}
						</Select>
					</FormControl> */}
				</>
			)}

			<ModalDashboardSettingComponent
				setting={filterData?.modalDashboardSetting}
				onChangeSetting={(value) => {
					onFilterDataChange('modalDashboardSetting', value)
				}}
				dataFields={displayJobColumns}
			/>
			<PlottingMapForm
				filterData={filterData}
				handleFilterDataChange={onFilterDataChange}
				taskMapSettingType={TASK_MAP_SETTING_TYPES.ALL}
				tileType={tileType}
			/>
		</Stack>
	)
}

export default NewJobSummaryForm
